package io.eqoty.secretk.types.response

@kotlinx.serialization.Serializable
data class AccountResponse(
    val account: Account
)